import React from "react"
import {WalletTopupServiceCharge} from "@irati/types"
import {Body} from "@irati/ui/src/Typography"
import {FormattedCurrency} from "@irati/utils/lang"
import {withTheme, WithDefaultTheme} from "styled-components"
import Flex from "@irati/ui/src/Flex"

interface Props extends WithDefaultTheme {
  amount: number,
  purchaseCurrency: string,
  serviceCharge: WalletTopupServiceCharge
}

const TopupServiceCharge: React.FC<Props> = ({theme, amount, purchaseCurrency, serviceCharge}) => {
  const ogFee = amount * serviceCharge.base!
  const nextFee = amount * serviceCharge.forNextTransfer!

  if (ogFee === nextFee) {
    return (
      <Body>
        <FormattedCurrency currency={purchaseCurrency} isCents={false} value={nextFee} />
      </Body>
    )
  }
  if (ogFee > 0 && nextFee === 0) {
    return (
      <Body color={theme.colors.tertiary.r_400} textDecoration="line-through">
        <FormattedCurrency currency={purchaseCurrency} isCents={false} value={ogFee} />
      </Body>
    )
  }

  return (
    <Flex direction="column">
      <Body color={theme.colors.tertiary.r_400} textDecoration="line-through">
        <FormattedCurrency currency={purchaseCurrency} isCents={false} value={ogFee} />
      </Body>
      <Body color={theme.colors.greys.black} marginRight={1}>
        <FormattedCurrency currency={purchaseCurrency} isCents={false} value={nextFee} />
      </Body>
    </Flex>
  )
}

export default withTheme(TopupServiceCharge)
